<script>
export default {
  name: "NameComponent",
  props: {
    pageAlias: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
    <div class="name">
      <router-link :to="'/oc/' + pageAlias">
        {{ index }}. {{ name }}
      </router-link>
      <font-awesome-icon icon="info-circle" />
    </div>
</template>

<style scoped>

.name {
  display: inline-block;
}

.name a {
  border-bottom: 1px dashed #000000;
  text-decoration: none;
  display: inline-block;
  margin-right: 5px;
  color: #000;
  margin-bottom: 10px;
}

.name a:hover {
  border-bottom: 1px dashed transparent;
}

.name svg {
  color: #b1b1b1;
}

</style>
